module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('programming-dashboard', {
    attrs: {
      "stationName": _vm.me.company_name,
      "isStreaming": _vm.me.is_streaming,
      "afstereoDataNotFound": _vm.afstereoDataNotFound,
      "date": _vm.selectedDate,
      "messagesData": _vm.messagesData,
      "audienceProfileData": _vm.audienceProfileData,
      "contentThreadsData": _vm.contentThreadsData,
      "promotionsData": _vm.promotionsData,
      "commercialLoadData": _vm.commercialLoadData,
      "musicalLoadData": _vm.musicalLoadData,
      "topTracksData": _vm.topTracksData,
      "timeslots": _vm.activeTimeslots,
      "timeslot": _vm.selectedTimeslot,
      "activeRange": _vm.activeRange,
      "period": _vm.selectedPeriod,
      "filtersLoading": _vm.filtersLoading,
      "dataLoading": _vm.dataLoading,
      "loadingStreamingData": _vm.loadingStreamingData,
      "loadingMessage": _vm.loadingMessage,
      "loadingAudienceData": _vm.audienceDataLoading,
      "stations": _vm.stations,
      "streamingData": _vm.streamingData,
      "selectedStation": _vm.selectedStation,
      "afstereoPluginEnabled": _vm.afstereoPluginEnabled,
      "loadingPlugins": _vm.loadingPlugins,
      "selectedEngagementsFilter": _vm.selectedFilter,
      "chartsData": _vm.chartsData,
      "mainChartData": _vm.mainChartData
    },
    on: {
      "onDateChange": _vm.handleDateChange,
      "onHeatMapDateChange": _vm.handleChangeDate,
      "onTimeslotChange": _vm.handleTimeslotChange,
      "onPeriodChange": _vm.handlePeriodChange,
      "onStreamingPeriodChange": _vm.handleStreamingPeriodChange,
      "onStationChange": _vm.handleStationChange,
      "previous": function($event) {
        return _vm.handlePrevious($event)
      },
      "next": function($event) {
        return _vm.handleNext($event)
      },
      "changeFilter": function($event) {
        return _vm.handleChangeFilter($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca5b1732","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/analytics/ProgrammingDashboardContainer.vue
// module id = 3393
// module chunks = 3